<template>
  <b-container>
    <b-row>
      <b-col cols="auto">
        <b-button
          @click="$emit('back')"
        >
          ย้อนกลับ
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button
          variant="success"
          @click="submitHandler"
        >
          บันทึก
        </b-button>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col>
        <b-form>
          <b-form-group
            id="set-test-name-group"
            label="ชื่อชุดตรวจ"
            label-for="set-test-name"
            class="text-left"
          >
            <template v-slot:label>
              ชื่อชุดตรวจ
              <span
                class="text-danger"
              >*
              </span>
            </template>
            <b-form-input
              id="set-test-name"
              v-model="setTestSelected.name"
            />
          </b-form-group>
          <b-row>
            <b-col
              cols="auto"
              class="my-auto"
            >
              รายการตรวจ
              <span
                class="text-danger"
              >*
              </span>
            </b-col>
            <b-col
              cols="auto"
              class="my-auto"
            >
              <b-button
                variant="success"
                @click="addDetailModalHandler"
              >
                เพิ่ม
              </b-button>
              <sweet-modal ref="detailAddModal">
                <sweet-modal-tab
                  id="test-tab"
                  title="Test"
                >
                  <b-form-input
                    v-model="testFilter"
                    @input="updateTestItems"
                  />
                  <b-table
                    ref="testTable"
                    style="height: 500px; overflow-y: auto; text-align: left;"
                    sticky-header
                    responsive
                    show-empty
                    select-mode="single"
                    selectable
                    thead-class="hidden_header"
                    :fields="fields"
                    :items="testSuggestList"
                    empty-text="ไม่มีผลลัพธ์"
                    @row-selected="onRowSelectedTest"
                  />
                </sweet-modal-tab>
              </sweet-modal>
            </b-col>
          </b-row>
          <b-row class="my-3">
            <div class="test-list">
              <template v-for="(test, index) in setTestSelected.tests">
                <b-row
                  :key="index"
                  class="text-left test-item mx-0"
                  align-h="between"
                >
                  <b-col>
                    {{ testName(test) }}
                  </b-col>
                  <b-col
                    class="col-right"
                  >
                    <b-button
                      variant="danger"
                      @click="deleteTest(test)"
                    >
                      ลบ
                    </b-button>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: "SetTestDetail",
    props: {
      value: {
        type: Object,
        default: () => ({
          id: null,
          name: null,
          tests: [],
        })
      }
    },
    data() {
      return {
        tests: [],
        testFilter: null,
        fields: [
          { key: 'name', label: 'ชื่อ', thStyle: { display: 'none'}}
        ],
        testSuggestList: [],
      }
    },
    computed: {
      setTestSelected: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    async mounted() {
      try {
        this.tests = await this.getTestList()
      } catch (e) {
        await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
      }
    },
    methods: {
      ...mapActions({
        getTestList: 'Settings/getTestList'
      }),
      testName(id) {
        const testSelected = this.tests.find(test => test.id === id)

        return testSelected ? testSelected.name : null
      },
      updateTestItems(text) {
        this.testSuggestList = this.tests.filter(testSuggestion => String(testSuggestion.name.toLowerCase()).includes(text.toLowerCase()))
      },
      async onRowSelectedTest(item) {
        if (item.length <= 0) {
          return
        }
        this.$refs['detailAddModal'].close();
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการเพิ่ม',
          text: `คุณต้องการเพิ่ม ${item[0].name} เข้ารายการใช่หรือไม่?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'เพิ่ม',
          cancelButtonText: 'ยกเลิก',
          showLoaderOnConfirm: true,
        })

        if (confirm.value) {
          this.setTestSelected.tests.push(item[0].id)
          await this.$swal.fire('สำเร็จ', 'เพิ่มรายการเรียบร้อย', 'success')
        } else {
          this.$refs['testTable'].clearSelected()
          this.$refs['setTestTable'].clearSelected()
          this.$refs['detailAddModal'].open()
        }
      },
      async addDetailModalHandler() {
        this.testSuggestList = this.$rfdc(this.tests) // clone test
        this.$refs['detailAddModal'].open()
      },
      async deleteTest(id) {
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการลบ',
          text: `คุณต้องการลบผลตรวจนี้ออกจากชุดตรวจใช่หรือไม่?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ลบ',
          cancelButtonText: 'ยกเลิก',
          showLoaderOnConfirm: true,
        })

        if (confirm.value) {
          this.setTestSelected.tests = this.setTestSelected.tests.filter(test => test !== id)
        }
      },
      async submitHandler() {
        if (!this.setTestSelected.name) {
          await this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณากรอกชื่อชุดตรวจ', 'error')
          return
        }
        if (this.setTestSelected.tests.length <= 0) {
          await this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณาเลือกผลตรวจอย่างน้อย 1 รายการ', 'error')
          return
        }

        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('submit', password)
        } else {
          return
        }

      }
    }
  }
</script>

<style lang="scss" scoped>
  .test-list {
    border: 1px solid black;
    width: 100%;
    height: 30vh;
    overflow-y: auto;

    .test-item {
      padding: 1rem;
      border-bottom: 1px solid black;

      &:last-child {
        border: none;
      }

    }
  }
</style>